import { render, staticRenderFns } from "./SuccessModalPix.vue?vue&type=template&id=7fa39d3b"
import script from "./SuccessModalPix.vue?vue&type=script&lang=js"
export * from "./SuccessModalPix.vue?vue&type=script&lang=js"
import style0 from "./SuccessModalPix.vue?vue&type=style&index=0&id=7fa39d3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports